type TemplateUser = {
  isSystemAdmin?: boolean;
  roles?: string[];
};

const TEMPLATE_MANAGEMENT_ROLES = ['admin', 'superadmin', 'systemadmin'];

export default function canManageStudioTemplates(user?: TemplateUser | null) {
  return (
    user?.isSystemAdmin === true ||
    user?.roles?.some((role) => TEMPLATE_MANAGEMENT_ROLES.includes(role)) ===
      true
  );
}
